import React, { Component } from "react";
const logoutUri = `${window.parent.origin}/logout`;
export default class RouteError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stopLogout: true
    };
  }

  logout = () => {
    window.location.replace(logoutUri);
  };
  render() {
    return <div />;
  }
}
